<div class="auth-card">
  <!-- Logo -->
  <a routerLink="/" class="auth-logo">
    <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
  </a>

  <!-- Header -->
  <div class="auth-header">
    <h1>{{ 'auth.login.title' | translate }}</h1>
    <p>{{ 'auth.login.subtitle' | translate }}</p>
  </div>

  <!-- Login Failed Alert -->
  <div *ngIf="isLoginFailed" class="alert alert-error">
    <i class="fa fa-exclamation-circle"></i>
    <div>
      <strong>{{ 'auth.login.failed' | translate }}</strong>
      <p class="mb-0">{{ 'auth.login.failedMessage' | translate }}</p>
    </div>
  </div>

  <!-- Login Form -->
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <!-- Email Field -->
    <div class="form-group">
      <label for="email" class="form-label">{{ 'auth.common.email' | translate }}</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="form-control"
        [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
        [placeholder]="'auth.common.emailPlaceholder' | translate"
        required
      />
      <span *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="invalid-feedback">
        {{ 'auth.common.emailInvalid' | translate }}
      </span>
    </div>

    <!-- Password Field -->
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label for="password" class="form-label mb-0">{{ 'auth.common.password' | translate }}</label>
        <a routerLink="/auth/forgot-password" class="auth-link-small" style="font-size: 13px; margin: 0;">{{ 'auth.login.forgotPassword' | translate }}</a>
      </div>
      <div class="password-toggle">
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          [placeholder]="'auth.common.passwordPlaceholder' | translate"
          required
        />
        <i
          [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('password')"
        ></i>
      </div>
      <span *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="invalid-feedback">
        {{ 'auth.common.passwordRequired' | translate }}
      </span>
    </div>

    <!-- Login Button -->
    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="loginForm.invalid"
      >
        {{ 'auth.login.signIn' | translate }}
      </button>
    </div>
  </form>

  <!-- Divider -->
  <div class="auth-divider">
    <span>{{ 'auth.common.or' | translate }}</span>
  </div>

  <!-- Register Link -->
  <button
    type="button"
    class="btn btn-outline"
    routerLink="/auth/register-user"
  >
    {{ 'auth.login.createAccount' | translate }}
  </button>
</div>
